import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 1,
  class: "ftimer-body"
}
const _hoisted_3 = {
  class: "ftimer-time",
  "aria-live": "off"
}
const _hoisted_4 = {
  key: 0,
  class: "ftimer-done",
  role: "status"
}
const _hoisted_5 = {
  key: 1,
  class: "ftimer-sub"
}
const _hoisted_6 = { class: "ftimer-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$store.state.timer.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "panel",
        class: _normalizeClass(["ftimer", _ctx.status]),
        style: _normalizeStyle({ left: _ctx.pos.x + 'px', top: _ctx.pos.y + 'px' }),
        role: "dialog",
        "aria-label": "Timer"
      }, [
        _createElementVNode("div", {
          class: "ftimer-head",
          title: "Drag to move",
          onPointerdown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "13",
              r: "8"
            }),
            _createElementVNode("path", { d: "M12 9v4l2.5 2.5M10 2h4M12 2v3" })
          ], -1)),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Timer", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "ftimer-x",
            "aria-label": "Close timer",
            title: _ctx.status == 'running' ? 'Close (keeps running)' : 'Close',
            onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.timer.open = false))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ]))], 40, _hoisted_1)
        ], 32),
        (_ctx.status == 'idle')
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "ftimer-body",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.start()), ["prevent"]))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "ftimer-label",
                for: "ftimer-minutes"
              }, "Minutes", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ftimer-minutes",
                ref: "minutesInput",
                type: "number",
                min: "1",
                max: "600",
                step: "1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minutes) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.minutes,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("button", { class: "btn ftimer-btn" }, "Start Timer", -1))
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1),
              (_ctx.status == 'done')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Time's up"))
                : (_ctx.status == 'paused')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Paused"))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.status == 'running')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn-light ftimer-btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pause()))
                    }, "Pause"))
                  : (_ctx.status == 'paused')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn ftimer-btn",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resume()))
                      }, "Resume"))
                    : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(_ctx.status == 'done' ? 'btn ftimer-btn' : 'btn-light ftimer-btn'),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reset()))
                }, _toDisplayString(_ctx.status == 'done' ? 'Done' : 'Reset'), 3)
              ])
            ]))
      ], 6))
    : _createCommentVNode("", true)
}